export default __webpack_public_path__ + "static/media/AfterPhoto4.f277c4ab.jpg";